import { render } from "./PricingReportDetails.vue?vue&type=template&id=961483ac&scoped=true"
import script from "./PricingReportDetails.vue?vue&type=script&lang=js"
export * from "./PricingReportDetails.vue?vue&type=script&lang=js"

import "./PricingReportDetails.vue?vue&type=style&index=0&id=961483ac&lang=css"
import "./PricingReportDetails.vue?vue&type=style&index=1&id=961483ac&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-961483ac"]])

export default __exports__